import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import Services from "../ones/Services";
import HomeBanner3 from "../ones/HomeBanner3";
import PartnersBanner from "../ones/HomeBanner4";
import Staff from "../ones/Staff";
import Clients from "../ones/Clients";
import Products from "../ones/Products";
import Portfolio from "../ones/Portfolio";
import Testimonials from "../ones/Testimonials";
import Werenium from "../ones/Werenium";
import NewsBanner from "../ones/NewsBanner";
import Word from "../ones/Word";
import GalleryBanner from "../ones/GalleryBanner";


export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<HomeBanner1/>
				<HomeBanner3/>
				<Werenium/>
				<Services/>
				<Clients/>
				<Testimonials/>
				<Products/>
				<Word/>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}